import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { noop } from 'lodash/noop';

import PopoverAnchor from 'common/components/PopoverAnchor';
import ColorPicker from './ColorPicker';

const BASE_CLASS_NAME = 'ColorPickerEditor';

export default class ColorPickerEditor extends Component {
    static propTypes = {
        colorList: PropTypes.arrayOf(PropTypes.object),
        firstColor: PropTypes.object,
        firstColorLabel: PropTypes.string,
        changeFirstColor: PropTypes.func,
        secondColor: PropTypes.object,
        secondColorLabel: PropTypes.string,
        changeSecondColor: PropTypes.func,
        'aria-label': PropTypes.string,
        qaId: PropTypes.string,
    };

    static defaultProps = {
        colorList: [],
        firstColor: null,
        firstColorLabel: '',
        changeFirstColor: noop,
        secondColor: null,
        secondColorLabel: '',
        changeSecondColor: noop,
        'aria-label': undefined,
        qaId: '',
    };

    render() {
        const {
            colorList,
            firstColor,
            firstColorLabel,
            changeFirstColor,
            secondColor,
            secondColorLabel,
            changeSecondColor,
            qaId,
            'aria-label': ariaLabel,
        } = this.props;

        return (
            <div className={BASE_CLASS_NAME}>
                <PopoverAnchor>
                    {firstColor || firstColorLabel ? (
                        <ColorPicker
                            colorList={colorList}
                            color={firstColor}
                            label={firstColorLabel}
                            aria-label={ariaLabel}
                            changeColor={changeFirstColor}
                            qaId={`${qaId}--firstColorQa`}
                        />
                    ) : (
                        <React.Fragment />
                    )}
                    {secondColor || secondColorLabel ? (
                        <ColorPicker
                            colorList={colorList}
                            color={secondColor}
                            label={secondColorLabel}
                            changeColor={changeSecondColor}
                            qaId={`${qaId}--secondColorQa`}
                        />
                    ) : (
                        <React.Fragment />
                    )}
                </PopoverAnchor>
            </div>
        );
    }
}
